import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { TrackingService } from '../services/tracking.service';


@Directive({ selector: '[documentTracking]' })
export class documentTrackingDirective implements OnInit {

  constructor(private elementRef: ElementRef, private trackingService: TrackingService) { }


  ngOnInit(): void {

  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    this.GetElement();
  }


  GetElement(): void {

    var docName = this.elementRef.nativeElement.attributes['data-docname'].value;
    var url = this.elementRef.nativeElement.attributes['data-url'].value;

    this.trackDocument(docName, url);

  }

  trackDocument(docName, url) {
    this.trackingService.TrackStaticDocument(docName, url).subscribe(res => { });
  }
}
